<template>
<div class="my-index">
   
    <div class="hnw-area-center my-body">
        <!-- v-if="tempNum==1" -->
        <ul class="my-menu" v-if="tempNum==1 || tempNum==3">
            <li class="my-logo">
                <div class="head-portrait">
                    <img :src="$store.state.member_avatar || require('../../assets/index/home/face.svg')" alt="">
                </div>
                <div class="logo-name">{{$store.state.company_name_jc}}</div>
                <div class="logo-info">{{$store.state.nickname}} / {{$store.state.position}}</div>
            </li>
            <li style="background-color:#F7F7F7; padding: 5px 0;"></li>
           
            <li v-for="(menu,index) in combinedMenuList" :key="index" :class="{'active': isMenuActive(menu)}" @click="toPath(menu)">
                <span >
                    <img v-if="!isMenuActive(menu)" :src="require(`../../assets/my/msg/${menu.img}.png`)" alt="">
                    <img v-else :src="require(`../../assets/my/msg/${menu.img1}.png`)" alt="">
                    {{menu.title}}
                </span>
            </li>
        </ul>

        <div class="my-container">
        <!--  -->
            <keep-alive include="orderIndex" v-if="!showIframe">
                <router-view/> 
            </keep-alive>    
            <iframe  v-show="showIframe" ref="myFrame"  :src="iframeUrl" frameborder="0" width="100%" height="100%" style="min-height: 610px;"></iframe>
        </div>
        <!--
            <template>
            </template> 
        -->
        <!-- 
            <template v-else-if="tempNum==2">
                <router-view/>
            </template> 
        -->
    </div>
</div>
</template>

<script>

export default {
    data(){
        return{
            tempNum:1,
            extendedMenuList: [], // 用于存储扩展的菜单列表
            iframeUrl: '', 
            // iframeUrl: 'https://huanuowei.cn/data/#/inveStatis', 
            // iframeUrl: 'https://huanuowei.cn/store/#/operation/advance', 
            // 用于存储iframe的URL,
            showIframe:false,
            activeExtendedMenu: null, // 用于跟踪当前激活的扩展菜单项
            lastActiveRoute: '' // 用于跟踪上一个激活的路由路径
        }
        
    },
    computed: {
        // 合并原始菜单和扩展菜单
        combinedMenuList() {
            if(this.$store.state.member_id=="1"||this.$store.state.storePath.includes("my/wxRobot")){
                this.extendedMenuList.push({
                    title: "微信机器人",
                    path: "/my/wxRobot",
                    img: "exchange",
                    img1: "exchange1"
                })
            }
            if(this.$store.state.store_id=="1780"&&this.$store.state.storePath.includes("newsList")){
                this.extendedMenuList.push({
                    title: "新闻资讯",
                    path: "/my/news",
                    img: "exchange",
                    img1: "exchange1"
                })
            }
            if(this.$store.state.store_id=="1989"||this.$store.state.member_id=="1"||this.$store.state.storePath.includes("arrivalAdmin")){
                // this.extendedMenuList.push({
                //     title: "延期管理",
                //     path: "/my/arrivalAdmin",
                //     img: "demand",
                //     img1: "demand1"
                // })
            }
            let menuList = this.$hnwTools.myMenuList;
            if (this.extendedMenuList.length > 0) {
                menuList = [...this.$hnwTools.myMenuList, ...this.extendedMenuList];
            }

            return menuList;
        },
    },
    
    methods:{
        // 判断菜单是否处于激活状态
        isMenuActive(menu) {
            // 如果是扩展菜单项，检查是否是当前激 活的扩展菜单
            if (menu.isExtended) {
                return this.activeExtendedMenu && this.activeExtendedMenu.path === menu.path;
            }
            // 如果不是扩展菜单项，使用路由判断逻辑，但要考虑扩展菜单激活的情况
            return !this.activeExtendedMenu && menu.path === this.$route.path;
        },
        toFrame(){
            const iframe = this.$refs.myFrame;
            if (iframe && iframe.contentWindow) {
                const messageData = {
                    type: 'web_open_store',
                    topUrl: window.location.href,
                    ps:251010,
                    member_id:this.$store.state.member_id,
                    member_name:this.$store.state.member_name
                }
                try {
                    // 发送消息到指定源，提高安全性
                    iframe.contentWindow.postMessage(messageData, '*');
                    console.log('消息已发送到 iframe');
                } catch (error) {
                    console.error('发送消息失败:', error);
                }
            } else {
                console.warn('无法获取 iframe 引用或 contentWindow');
            }
        },
        toPath(menu){
            // 检查是否为扩展菜单项（通过是否有isExtended属性判断）
            if(menu.isExtended){
                // 设置当前激活的扩展菜单项
                this.activeExtendedMenu = menu;
                
                if(menu.isData==1){
                    this.iframeUrl = `https://huanuowei.cn/data/#${menu.path}`;
                }else{
                    this.iframeUrl = `https://huanuowei.cn/store/#${menu.path}`;
                }
                // 设置iframe的URL
                this.toFrame()
                this.tempNum = 3; // 设置一个新的状态用于显示iframe
                this.showIframe = true
            } else {
                // 保存当前路由路径作为上一个激活的路由
                this.lastActiveRoute = this.$route.path;
                // 清除扩展菜单的激活状态
                this.activeExtendedMenu = null;

                // 原有的路由跳转逻辑
                if(menu.path.includes('message')){
                    let link = location.href.split("#")[0];
                    window.open(link + "#"+menu.path);
                }else{
                    this.$router.push(menu.path)
                }
                this.tempNum = 1; // 恢复到原始状态
                this.iframeUrl = ''; // 清空iframe URL
                this.showIframe = false
            }
        }
    },
    created(){
        
        
        if(this.$store.state.for_branch&&this.$store.state.for_branch!=1780){
            // console.log("goods");
            this.$hnwTools.myMenuList.forEach( item=> {
                if(item.title=='退货/换货'){
                    item.path = "/my/reBranchPart"

                }
            })
        }
        
       
        // 检查storePath字段是否存在，如果存在则解析并添加到菜单列表
        if(this.$store.state.store_id==1780&&this.$store.state.storePath){

            try {
                // const parsedMenu = this.$store.state.storePath;
                console.log("this.$store.state.storePath", this.$store.state.storePath);
                
                const parsedMenu = JSON.parse(this.$store.state.storePath);
                if(Array.isArray(parsedMenu)) {
                    // 为扩展菜单项添加默认的img和img1属性，并添加isExtended标识
                    const extendedMenu = parsedMenu.map(item => ({
                        ...item,
                        img: item.img || "enterprise",    // 默认值
                        img1: item.img1 || "enterprise1",  // 默认值
                        isExtended: true  // 标识为扩展菜单项
                    }));
                    // showMenu
                    this.extendedMenuList = extendedMenu.filter(item=>!item.hideMenu);
                    
                }else{
                    
                }
            } catch (e) {
                console.error("解析storePath失败", e);
            }
            this.iframeUrl = 'https://huanuowei.cn/store/#/operation/operPosAudit';
            this.toFrame()
            
            // 判断是否是点击海报审核通知过来的
            if (this.$route.query.from === 'posterAudit') {
                this.$nextTick(() => {
                    let item = this.extendedMenuList.find(item => item.path === '/operation/operPosAudit')
                    if (item) {
                        this.toPath(item)
                    }
                });
            }
        }

        console.log("is_limit",this.$store.state.is_limit);
        
    },
    
    watch:{
        "$route.path":{
            deep:true,
            immediate:true,
            handler(n){
                // 定义需要设置tempNum为2的路径前缀
                const pathsWithTempNum2 = [
                    '/my/orderInfo',
                    '/my/ReSales',
                    '/my/BranchReSales/',
                    '/my/RefundInfo',
                    
                ];
                
                // 检查当前路径是否以任一指定前缀开始
                if (pathsWithTempNum2.some(path => n.startsWith(path))) {
                    this.tempNum = 2;
                    this.iframeUrl = ''; // 清空iframe URL
                    this.activeExtendedMenu = null; // 清除扩展菜单激活状态
                } else {
                    this.tempNum = 1;
                    this.iframeUrl = ''; // 清空iframe URL
                    this.activeExtendedMenu = null; // 清除扩展菜单激活状态
                }
            }
        }
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.my-index{
    background: $backGray;
  
    .my-body{
        padding-top: 10px;
        display: flex;
        .my-menu{
            min-width: 148px;
            max-width: 148px;
            background: #fff;
            .my-logo{
                min-width: 148px;
                max-width: 148px;
                display: inline-block;
                height: 148px;
                padding: 0;
                .head-portrait{
                    width: 58px;
                    height: 58px;
                    border-radius: 58px;
                    overflow: hidden;
                    border: 2px solid #f7f7f7;
                    margin: 20px 0 0 42px;
                    >img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .logo-name{
                    text-align: center;
                    color: #333333;
                    font-size: 16px;
                    margin: 10px 0 7px 0;
                }
                .logo-info{
                    text-align: center;
                    color: #999;
                    font-size: 14px;
                }
            }
            li{
                text-align: center;
                cursor: pointer;
                padding: 10px 0;
                    color: #666;
                span{
                    img{
                        width: 20px;
                        height: 20px;
                         vertical-align: middle;
                    }
                }
            }
            .active{
                // color: #3E84D6;
                color: #fff;
                background-color: #3E84D6;
            }
            .menu-title{
                cursor: default;
            }
        }
        .my-container{
            margin-left: 10px;
            flex: 1;
        }
    }
}
</style>